import { SyntheticEvent } from "react";
import { Autocomplete, TextField } from "@mui/material";

interface Props {
  label: string;
  value: { label: string; value: string } | null;
  onChange: (
    event: SyntheticEvent<Element, Event>,
    value: { label: string; value: string } | null
  ) => void;
  options: { label: string; value: string }[];
  className?: string;
  isOptionEqualToValue?: (option: { label: string; value: string }, value: { label: string; value: string }) => boolean;
}

const InputAutocomplete = ({
  label,
  value,
  onChange,
  options,
  className,
  isOptionEqualToValue,
}: Props) => (
  <Autocomplete
    className={`InputAutocomplete ${className}`}
    disablePortal
    value={value}
    getOptionLabel={(option) => option.label}
    getOptionKey={(obj) => obj.value}
    onChange={onChange}
    options={options}
    isOptionEqualToValue={isOptionEqualToValue}
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);

export default InputAutocomplete;
